import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Chip, Stack } from '@mui/material';

import SupplierRoomsForInternalRoomList from '~/components/Accommodation/Pages/PropertyDetails/sections/AccommodationPropertyRoomMapping/SupplierRoomsForInternalRoomList';

import { InternalRoom } from '~/services/AccommodationService';

interface Props {
  internalRoomId: string;
  unsavedInternalRooms: Array<InternalRoom>;
}

export default function ToBeMappedRoomElement({ internalRoomId, unsavedInternalRooms }: Props) {
  const room = unsavedInternalRooms.find((r) => r.id === internalRoomId);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={(_e, nextIsExpanded) => setIsExpanded(nextIsExpanded)}
      sx={{
        borderColor: 'info.light',
        borderWidth: '2px',
        borderStyle: 'solid',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" gap={1}>
          <Chip label="Unsaved" color="info" size="small" />
          <Chip label="Verified" color="success" variant="outlined" size="small" />
          <span>
            ({room.internalService}) {room.name} - {room.internalServiceId}
          </span>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <SupplierRoomsForInternalRoomList internalRoomId={internalRoomId} isExpanded={isExpanded} />
      </AccordionDetails>
    </Accordion>
  );
}
